import React, { useState, useEffect } from 'react';
import { Form, Container, Button, Card, Spinner, Modal } from 'react-bootstrap';
import { initializeApp } from "firebase/app";
import { getFirestore, getDoc, doc, updateDoc, increment } from "firebase/firestore";
// import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import './/../Global/shared-css.css';
import Err404 from './404';
import LoadingSceen from './Loading/Loading';
import CryptoJS from 'crypto-js';

const firebaseConfig = {
    apiKey: "AIzaSyCXxNVxVEYMUPP1oF-aatik7-yrKOZk8dY",
    authDomain: "gonugmm.firebaseapp.com",
    databaseURL: "https://gonugmm-default-rtdb.firebaseio.com",
    projectId: "gonugmm",
    storageBucket: "gonugmm.appspot.com",
    messagingSenderId: "1012307687730",
    appId: "1:1012307687730:web:6f5faa7be878fec826bf2b",
    measurementId: "G-Y4YTBW7HJZ"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

function ProtectedPage() {
    const [userInputedPassword, setUserInputedPassword] = useState(''); // [state, setState
    const [linkPassword, setLinkPassword] = useState('');
    const [isVerified, setIsVerified] = useState(false);
    const [redirectUrl, setRedirectUrl] = useState('');
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showIncorrectModal, setShowIncorrectModal] = useState(false);

    // const navigate = useNavigate();

    const EncryptedValue = 'XX2sJnT9(Q)<Z!TP19lP4Dc4@*>>QZ';

    function decryptPassword(password, EncryptedKey) {
        try {
            const bytes = CryptoJS.AES.decrypt(password, EncryptedKey);
            const originalText = bytes.toString(CryptoJS.enc.Utf8);
            return originalText;
        } catch (error) {
            setShowIncorrectModal(true);
            console.error('Failed to decrypt or parse the password:', error);
            return null;
        }
    }

    let params = new URLSearchParams(window.location.search);
    let cpass = params.get('cpass');

    useEffect(() => {
        // Fetch user document with specific email from Firestore
        const fetchData = async () => {
            setLoading(true);
            const docRef = doc(db, 'goto', cpass.substring(1));
            const docSnap = await getDoc(docRef);

            if (docSnap.exists()) {
                const linkpassword = docSnap.data().password;
                const redirectUrl = docSnap.data().url;
                setRedirectUrl(redirectUrl);
                setLinkPassword(linkpassword);
                await updateDoc(docRef, {
                    clicks: increment(1)
                });
            } else {
                <Err404 />
            }
            setLoading(false);
        };

        fetchData();
    }, [cpass.substring(1)]); // Dependency array

    const handleFormSubmit = (event) => {
        event.preventDefault();
        if (userInputedPassword === '') {
            setShowModal(true);
        } else {
            if (decryptPassword(linkPassword, EncryptedValue) == userInputedPassword) {
                window.location.replace(redirectUrl)
                setIsVerified(true);
            } else if (decryptPassword(linkPassword, EncryptedValue) != userInputedPassword) {
                setShowIncorrectModal(true);
            } else {
                setShowIncorrectModal(true);
            }
        }

    };

    // const bytes = CryptoJS.AES.decrypt(dbPassword, 'XX2sJnT9(Q)<Z!TP19lP4Dc4@*>>QZ');
    // const decryptedPass = bytes.toString(CryptoJS.enc.Utf8);

    if (!isVerified) {
        return (
            loading ? <LoadingSceen /> :
                <>

                    < Container fluid className='passcontainer bg-light align-items-center d-flex navless-container' >
                        <Card className='m-auto formwidth passCard'>
                            <div className="d-flex">
                                <img src="https://cdn.egov.nugmyanmar.org/assets/state/go.nugonlylogo.png" width={80} className="godotnuglogo align-items-center" />
                                <div className="passtitle">
                                    <p className="text-left h4 protectTitle">Password Protected</p>
                                    <span className="text-left text-mute redirectLink">go.nugmyanmar.org/{cpass.substring(1)}</span>
                                </div>
                            </div>
                            <Form onSubmit={handleFormSubmit} >
                                <Form.Group className="my-3" controlId="formPassword">
                                    <Form.Label>Password</Form.Label>
                                    <Form.Control
                                        required
                                        type="password"
                                        placeholder="Enter the password.."
                                        onChange={e => setUserInputedPassword(e.target.value)} />
                                    <Form.Text className="text-muted smallinfo">If you do not have the password, please contact the agency responsible for providing you with the short link.</Form.Text>
                                </Form.Group>
                                <div className="d-grid gap-2">
                                    <Button
                                        variant="danger"
                                        type="submit"
                                        className='loginBtn'
                                        onClick={(event) => handleFormSubmit(event)}>
                                        Submit
                                    </Button>
                                </div>
                            </Form>
                        </Card>

                    </Container >
                    <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                        <Modal.Header closeButton>
                            <Modal.Title>Warning</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>Please enter the password.</Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={() => setShowModal(false)}>
                                Close
                            </Button>
                        </Modal.Footer>
                    </Modal>
                    <Modal show={showIncorrectModal} onHide={() => setShowIncorrectModal(false)} centered>
                        <Modal.Header closeButton>
                            <Modal.Title>Warning</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>Incorrect password! or Something went wrong. Please try again.</Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={() => setShowIncorrectModal(false)}>
                                Close
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </>
        );
    } else if (isVerified) {

        return (
            < Container fluid className='passcontainer bg-light align-items-center d-flex navless-container' >
                <Card className='m-auto formwidth passCard'>
                    <div className="d-flex">
                        <Spinner animation="grow" variant="danger" />
                        <div className="passtitle">
                            <p className="text-left h4 protectTitle">Redirecting...</p>
                            <spam className="text-left text-mute redirectLink">go.nugmyanmar.org/{cpass.substring(1)}</spam>
                        </div>
                    </div>
                </Card>

            </Container >
        );
    }
}

ProtectedPage.propTypes = {
    isProtected: PropTypes.bool,
    correctPassword: PropTypes.string,
    fsRedirectUrl: PropTypes.string,
    isActive: PropTypes.bool,
    loading: PropTypes.bool,
};

export default ProtectedPage;